(() => {

/**
 * For any list of `.inlineList--pipe > .inlineList__item`, if an item is teh last one on the line, it will remove the `|` separator
 */ function $f1a239bd51d94984$export$2e2bcd8739ae039() {
    const items = document.querySelectorAll(".inlineList--pipe .inlineList__item");
    let previousY;
    items.forEach((item, index)=>{
        const bbox = item.getBoundingClientRect();
        if (bbox.y !== previousY) {
            const previous = items[index - 1];
            if (previous) previous.style.setProperty("--inlineListSep", "''");
        }
        previousY = bbox.y;
    });
}


(0, $f1a239bd51d94984$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=inline-list.js.map
